/********************************************************************************
 * Copyright (c) 2019-2022 EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

.sprotty-graph {
    font-size: 15pt;
    border: none;
    height: 100%;
}

.sprotty-text {
    font-size: 12pt;
    text-anchor: middle;
}

.sprotty-node {
    stroke-width: 0;
    font-weight: bold;
}

.sprotty-label {
    stroke-width: 0;
    fill: #000;
    font-weight: inherit;
    text-align: inherit;
    font-size: 100%;
    user-select: none;
}

.sprotty-label.heading {
    font-weight: normal;
    font-size: 0.7em;
    fill: #f0f3f8;
}

.icon path {
    stroke-width: 0;
    fill: #f0f3f8;
}

.icon .icon-background {
    fill: transparent;
}

.task.automated > .sprotty-node {
    fill: #5b9fa8;
}

.task.manual > .sprotty-node {
    fill: #db8651;
}

.category > .sprotty-node {
    fill: #5c87bd;
}

.category .category > .sprotty-node {
    /** Add a border to nested categories, so we can distinguish them */
    stroke: #38679a;
    fill: #6f9ad0;
    stroke-width: 1;
}

.sprotty-edge.weighted.low:not(.selected, .navigable-element, .search-highlighted),
.sprotty-edge.weighted.low:not(.selected, .navigable-element, .search-highlighted) .arrow {
    stroke: rgb(128, 90, 233);
}

.sprotty-edge.weighted.low:not(.selected, .navigable-element, .search-highlighted) .arrow {
    fill: rgb(128, 90, 233);
}

.sprotty-edge.weighted:not(.selected, .navigable-element, .search-highlighted),
.sprotty-edge.weighted:not(.selected, .navigable-element, .search-highlighted) .arrow,
.sprotty-edge.weighted.medium:not(.selected, .navigable-element, .search-highlighted),
.sprotty-edge.weighted.medium:not(.selected, .navigable-element, .search-highlighted) .arrow {
    stroke: rgb(98, 60, 193);
}

.sprotty-edge.weighted:not(.selected, .navigable-element, .search-highlighted) .arrow,
.sprotty-edge.weighted.medium:not(.selected, .navigable-element, .search-highlighted) .arrow {
    fill: rgb(98, 60, 193);
}

.sprotty-edge.weighted.high:not(.selected, .navigable-element, .search-highlighted),
.sprotty-edge.weighted.high:not(.selected, .navigable-element, .search-highlighted) .arrow {
    stroke: rgb(68, 30, 163);
}

.sprotty-edge.weighted.high:not(.selected, .navigable-element, .search-highlighted) .arrow {
    fill: rgb(68, 30, 163);
}

.sprotty-comp {
    stroke: transparent;
    fill: transparent;
}

.label-edit input {
    margin-top: -3px;
    margin-left: -3px;
}
